// server-error-page.component.ts
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServerErrorService } from '../core/services/server-error.service';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { Library } from 'app/core/library';

@Component({
  selector: 'app-server-error-page',
  templateUrl: './server-error-page.component.html',
  styleUrls: ['./server-error-page.component.scss']
})
export class ServerErrorPageComponent implements OnInit {
  private previousUrl: string = '/';
  isRetrying: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private serverErrorService: ServerErrorService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    // Get the URL user was trying to access before error
    this.previousUrl = this.serverErrorService.getPreviousUrl() || '/';

    // If there's no actual server error, redirect back
    if (!this.serverErrorService.hasServerError()) {
      this.router.navigate([this.previousUrl]);
    }
  }

  retry(): void {
    this.isRetrying = true;

    // Test if server is back online by making a simple API call
    // Replace with your actual API endpoint
    const testUrl =  Library.API_ENDPOINT + 'common/countries';

    this.http.get(testUrl).pipe(
      catchError((error) => {
        console.error('Server still down:', error);
        return of(null);
      })
    ).subscribe({
      next: (response) => {
        this.isRetrying = false;

        if (response !== null) {
          // Server is back online!
          console.log('Server is back online. Clearing error state...');
          this.serverErrorService.clearServerError();

          // Navigate back to the previous URL
          this.router.navigateByUrl(this.previousUrl);

          // Reload to re-initialize the app
          window.location.reload();
        } else {
          // Server still down
          console.log('Server is still down. Please try again.');
          alert('Server is still unreachable. Please try again in a moment.');
        }
      },
      error: (err) => {
        this.isRetrying = false;
        console.error('Error testing server:', err);
        alert('Server is still unreachable. Please try again in a moment.');
      }
    });
  }
}